import { render, staticRenderFns } from "./AlbaranesList.vue?vue&type=template&id=060d47b6&scoped=true&"
import script from "./AlbaranesList.vue?vue&type=script&lang=js&"
export * from "./AlbaranesList.vue?vue&type=script&lang=js&"
import style0 from "./AlbaranesList.vue?vue&type=style&index=0&id=060d47b6&lang=scss&scoped=true&"
import style1 from "./AlbaranesList.vue?vue&type=style&index=1&lang=css&"
import style2 from "./AlbaranesList.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060d47b6",
  null
  
)

export default component.exports